__turbopack_context__.v({
  "caption": "ei30fa_caption",
  "content": "ei30fa_content",
  "foodTime": "ei30fa_foodTime",
  "full": "ei30fa_full",
  "header": "ei30fa_header",
  "lg": "ei30fa_lg",
  "lightBentoBox": "ei30fa_lightBentoBox",
  "progress": "ei30fa_progress",
  "progressBar": "ei30fa_progressBar",
  "root": "ei30fa_root" + " " + __turbopack_context__.i(768839)["sectionPadding"],
  "sm": "ei30fa_sm",
  "visualisationContainer": "ei30fa_visualisationContainer",
});
